/*
 * @Author: 陈祖康
 * @Date: 2021-03-26 14:59:16
 * @LastEditors: 陈祖康
 * @LastEditTime: 2021-03-26 14:59:23
 * @Description: 
 * @Props: 
 * @Emit: 
 */
export function isArray(value: any): value is Array<any> {
  return typeof value !== "undefined" && value instanceof Array;
}

export function isObject(value: any): value is Record<string, any> {
  return value !== null && typeof value === "object";
}